import { render, staticRenderFns } from "./TransitionBanner.vue?vue&type=template&id=5e4a528a&scoped=true"
import script from "./TransitionBanner.vue?vue&type=script&lang=js"
export * from "./TransitionBanner.vue?vue&type=script&lang=js"
import style0 from "./TransitionBanner.vue?vue&type=style&index=0&id=5e4a528a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4a528a",
  null
  
)

export default component.exports